import { Component } from '@angular/core';

@Component({
  selector: 'app-forbidden',
  standalone: true,
  templateUrl: './forbidden.html',
  styleUrl: './forbidden.scss',
})
export class ForbiddenComponent {}

